import React from 'react';
import styled from 'styled-components';

const Img = styled.img`
  border-radius: 16px;
  background-color:var(--color-foreground);
  width: 100%;
  margin: 1rem auto;
`;



const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Image = (props) => {
  return (
    <Flex>
      <Img {...props}/>
    </Flex>
  )
}
export default Image;